<template>
    <b-modal id="edit_subscriber_modal" @ok="editSubscriber" size="l" no-close-on-backdrop>
        <template slot="modal-title">Edit a subscriber</template>
        <form ref="edit_subscriber_form">
            <b-form-group
                    label="Name"
                    label-for="name">
                <b-form-input
                        id="name"
                        :state="validateName"
                        v-model="selected_subscriber.name"
                        autofocus
                        required/>
                <b-form-invalid-feedback :state="validateName">
                    Name is invalid, it needs at least {{minNameLength}} characters.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Active"
                    label-for="active">
                <b-form-checkbox
                        id="active"
                        v-model="selected_subscriber.active"
                        required/>
            </b-form-group>
            <b-form-group
                    label="Queue Priority"
                    label-for="priority">
                <b-form-input
                        id="priority"
                        type="range"
                        min="0"
                        max="10"
                        :state="validatePriority"
                        v-model="selected_subscriber.priority" required/>
                {{ selected_subscriber.priority }}
                <b-form-text id="queueCategory-help">Higher is more important.</b-form-text>
                <b-form-invalid-feedback :state="validatePriority">
                    The priority needs to be a number.
                </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group
                    label="Queue Category"
                    label-for="queueCategory">
                <b-form-input
                        id="queueCategory"
                        placeholder="order_queue"
                        v-model="selected_subscriber.queueCategory"/>

                <b-form-text id="queueCategory-help">Optional. Leave empty for the default queue category.</b-form-text>
            </b-form-group>
        </form>
    </b-modal>
</template>

<script>
    import SubscriberRepository from '../../repositories/subscriber.repository';

    export default {
        props: {
            selected_subscriber: {
                type: Object,
                default: SubscriberRepository.blankSubscriber
            }
        },
        data() {
            return {minNameLength: process.env.VUE_APP_VALIDATION_SUBSCRIBER_MIN_NAME_LENGTH}
        },
        methods: {
            checkFields() {
                if (SubscriberRepository.validate.name(this.selected_subscriber.name) === false) return false;
                return true;
            },
            editSubscriber(modal) {
                if (this.$refs.edit_subscriber_form.checkValidity() && this.checkFields()) {
                    this.$emit('show-loading-pop-up', 'Saving the changes to the selected subscriber.');
                    SubscriberRepository.put(this.selected_subscriber.id, this.selected_subscriber).then(res => {
                        // Emit the subscriber edited event
                        this.$emit('reset-loading-pop-up');
                        this.$emit('subscriber-edited', res.data);
                        // Notify the user.
                        this.$bvToast.toast(`Subscriber ${res.data.name} successfully edited.`, {
                            title: `Subscriber edited.`,
                            variant: 'success',
                            solid: true
                        });
                    }).catch(error => {
                        this.$emit('reset-loading-pop-up');
                        if (error.response.status === 422) {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText + " \n details:" + error.response.data['hydra:description']);
                            this.$bvToast.toast('Looks like something went wrong while validating the subscriber. Check the value\'s of all the fields', {
                                title: `Subscriber validation error.`,
                                variant: 'danger',
                                solid: true
                            });
                        } else {
                            console.error("Errorcode: " + error.response.status + " Type: " + error.response.statusText);
                            this.$bvToast.toast('Looks like something went wrong on the server while editing the subscriber.', {
                                title: `Subscriber edit error.`,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    });
                } else {
                    modal.preventDefault();
                }
            }
        },
        computed: {
            validateName() {
                return SubscriberRepository.validate.name(this.selected_subscriber.name);
            },
            validatePriority() {
                return SubscriberRepository.validate.priority(this.selected_subscriber.priority);
            }
        }
    }
</script>
